import React, { useEffect, useState } from "react";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { getAlldata } from "../../controllers/APIController";
import ExcelTemplate from "./ExcelTemplate";
import ImportDataButton from "./ImportDataButton";
import { Button, useDisclosure } from "@nextui-org/react";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import AddTemplateModal from "./AddTemplateModal";
import LoadingPage from "../../components/Loader/LoadingPage";
import {
  importSectionDescription,
  mainDescription,
  mainHeading,
} from "../../constant/DataImport/dataimport.constant";

const DataImport = () => {
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;

  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const { OrgDetail: DefaultOrgDetail, isLoading: isLoadingDefaultOrg } =
    useGetDefaultOrg();
  const [TemplateData, setTemplateData] = useState([]);

  const [reRenderPage, setReRenderPage] = useState(true);
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const isDefaultOrg = DefaultOrgDetail?.id === OrgInfo;

  useEffect(() => {
    getAlldata("templates")
      .then((data) => {
        setTemplateData(data?.data);
        setIsLoadingPage(false);
      })
      .catch((err) => console.log(err));
  }, [reRenderPage]);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Page Header */}
      <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div>
            <h1 className="text-2xl font-semibold text-slate-900">{mainHeading}</h1>
            <p className="text-sm text-slate-600 mt-1">{mainDescription}</p>
          </div>
          {isDefaultOrg && (
            <Button 
              color="primary" 
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
              onClick={onOpen}
            >
              Create Template
            </Button>
          )}
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          <LoadingPage isLoading={isLoadingPage || isLoadingDefaultOrg} loadingText="Loading templates...">
            {/* Template Management Section */}
            <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-6 mb-8">
              <div>
                <h2 className="text-lg font-semibold text-slate-900">Template Management</h2>
                <p className="text-sm text-slate-600 mt-1">
                  Browse and manage Excel templates for data import. Choose from available templates or create new ones to streamline your data import process.
                </p>
              </div>
            </div>

            {/* Template Repository Section */}
            <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden mb-8">
              <div className="px-6 py-4 border-b border-slate-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">Template Repository</h3>
                    <p className="text-sm text-slate-600 mt-1">Browse and manage Excel templates</p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {TemplateData?.map((data) => (
                    <ExcelTemplate
                      key={data.id}
                      data={data}
                      isDefaultOrg={DefaultOrgDetail?.id === OrgInfo}
                      setReRenderPage={setReRenderPage}
                      reRenderPage={reRenderPage}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Import Data Section */}
            <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-slate-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">Import Your Data</h3>
                    <p className="text-sm text-slate-600 mt-1">{importSectionDescription}</p>
                  </div>
                  <ImportDataButton />
                </div>
              </div>
            </div>
          </LoadingPage>
        </div>
      </BreadCrumbsPage>

      <AddTemplateModal
        onSubmitHandler={1}
        id={1}
        isOpen={isOpen}
        onOpen={onOpen}
        onOpenChange={onOpenChange}
        setReRenderPage={setReRenderPage}
      />
    </div>
  );
};

export default DataImport;
